export default "__VITE_ASSET__0e9bb721__"